import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { DesignEditorPrimaryControls } from '../../../DesignEditor/components/DesignEditorControls';
import { CardDesignerLayoutControlsButton } from './components/CardDesignerLayoutControls';
import { CONTROL_SECTION } from '../../helpers';
import { CardDesignerBackgroundControlsButton } from './components/CardDesignerBackgroundControls';
import { CardDesignerElementsControlsButton } from './components/CardDesignerElementsControls';
import { CardDesignerLogoControlsButton } from './components/CardDesignerLogoControls';

const propTypes = {
  className: PropTypes.string,
  onControlSelect: PropTypes.func.isRequired,
  activeControlSection: PropTypes.string,
  forCollages: PropTypes.bool.isRequired,
};

const CardDesignerMainControlPanel = ({
  className,
  onControlSelect,
  activeControlSection,
  forCollages,
}) => {
  const classes = classNames({
    [className]: !!className,
  });

  return (
    <DesignEditorPrimaryControls className={classes}>
      {forCollages && (
        <CardDesignerLogoControlsButton
          active={activeControlSection === CONTROL_SECTION.LOGO}
          onClick={() => {
            onControlSelect(CONTROL_SECTION.LOGO);
          }}
        />
      )}
      <CardDesignerLayoutControlsButton
        active={activeControlSection === CONTROL_SECTION.LAYOUT}
        onClick={() => {
          onControlSelect(CONTROL_SECTION.LAYOUT);
        }}
      />
      <CardDesignerElementsControlsButton
        active={activeControlSection === CONTROL_SECTION.ELEMENTS}
        onClick={() => {
          onControlSelect(CONTROL_SECTION.ELEMENTS);
        }}
      />
      <CardDesignerBackgroundControlsButton
        active={activeControlSection === CONTROL_SECTION.BACKGROUND}
        onClick={() => {
          onControlSelect(CONTROL_SECTION.BACKGROUND);
        }}
      />
    </DesignEditorPrimaryControls>
  );
};

CardDesignerMainControlPanel.propTypes = propTypes;

export default CardDesignerMainControlPanel;
